// components/InputControlado.js
import { useState, useEffect, useRef } from "react";

const InputControlado = ({ value, onChange, type = "text", ...props }) => {
  const [internalValue, setInternalValue] = useState(value);

  const inputRef = useRef(null);
  const cursorPosition = useRef(0);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  //Essa função roda sempre que o usuário digita no input.

  const handleChange = (e) => {
    const { value, selectionStart } = e.target;

    // Só armazena a posição do cursor para inputs que suportam seleção
    if (type === "text" || type === "search" || type === "password") {
      cursorPosition.current = selectionStart;
    }

    setInternalValue(value);
    if (onChange) onChange(e);
  };

  //fim da função

  useEffect(() => {
    if (
      inputRef.current &&
      (type === "text" || type === "search" || type === "password")
    ) {
      try {
        inputRef.current.setSelectionRange(
          cursorPosition.current,
          cursorPosition.current,
        );
      } catch (error) {
        console.debug("Input não suporta seleção de cursor:", type);
      }
    }
  }, [internalValue, type]);

  return (
    <input
      ref={inputRef}
      type={type}
      value={internalValue}
      onChange={handleChange}
      {...props}
    />
  );
};

export default InputControlado;
